﻿import api from '../api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import { notification } from '@digital/ui';
import { Modal } from 'antd';

export interface ContratoPlanilhaQuantidadeContato {
  id: string;
  contratoId: string;
  numero: number;
  statusPlanilha: string;
  dataInclusao: Date;
  responsavel: string;
  aditivoRelacionado: string;
  valorTotal: number;
  dataInclusaoFormatada: string;
  valorContratoFormatado: string;
  identificador?: number;
  escopo?: string;
  isResponsavel?: boolean;
}

export interface PlanilhaQuantidadeTemporaria {
  id: string;
  contratoId: string;
  codigoItem: string;
  descricao: string;
  unidade: string;
  quantidade: string;
  percoUnitario: string;
  valorTotal: string;
  children: Array<PlanilhaQuantidadeTemporaria>;
}

export interface ContratoPlanilhaQuantidadeAtual {
  id: string;
  contratoId: string;
  tipoDocumentoCobrancaId: string;
  codigoItem: string;
  descricao: string;
  unidade: string;
  quantidade: string;
  precoUnitario: string;
  valorTotal: number;
  reprovada: boolean;
  children?: Array<ContratoPlanilhaQuantidadeAtual>;
  subItens?: Array<ContratoPlanilhaQuantidadeContato>;
  isResponsavel?: boolean;
  identificador?: string;

}

interface TipoDocumentoCobranca {
  id: string;
  nome: string;
  codigo: number;
  especieTotvs: string;
  automatico?: boolean;
  manual?: boolean;
}

export const getAllPlanilhaQuantidadeContratoByContrato = (id: any) =>
  api.get<ContratoPlanilhaQuantidadeContato[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeByContato/${id}`);

export const getAllPlanilhaQuantidadeMultiplosGestoresByContrato = (id: any) =>
  api.get<ContratoPlanilhaQuantidadeAtual[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeMultiplosGestoresByContato/${id}`);

export const getAllPlanilhaQuantidadeMultiplosGestoresByNumeroContrato = (numeroContrato: any) =>
  api.get<ContratoPlanilhaQuantidadeAtual[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeMultiplosGestoresByNumeroContrato/${numeroContrato}`);

export const getAllPlanilhaQuantidadeAtualByContrato = (id: any) =>
  api.get<ContratoPlanilhaQuantidadeAtual[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeAtualByContrato/${id}`);
export const getAllPlanilhaQuantidadeMultiplosGestoresAtual = (id: any, identificador: any) =>
  api.get<ContratoPlanilhaQuantidadeAtual[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeMultiplosGestoresAtual/${id}/${identificador}`);
export const getAllPlanilhaQuantidadeContratoTemporariaByContrato = (id: any) =>
  api.get<PlanilhaQuantidadeTemporaria[]>(
    `planilhaQuantidade/getAllPlanilhaQuantidadeContratoTemporariaByContrato/${id}`,
  );
export const getAllPlanilhaComStatusReprovado = (id: any) =>
  api.get<PlanilhaQuantidadeTemporaria[]>(`planilhaQuantidade/getAllPlanilhaComStatusReprovadoByContato/${id}`);
export const getAllPlanilhaComStatusAguardandoAprovacao = (id: any) =>
  api.get<PlanilhaQuantidadeTemporaria[]>(
    `planilhaQuantidade/getAllPlanilhaComStatusAguardandoAprovacaoByContato/${id}`,
  );

export const getAllPlanilhaQuantidadeAtualByContratoIds = (id: any) =>
  api.get<string[]>(`planilhaQuantidade/getAllPlanilhaQuantidadeAtualByContratoIds/${id}`);

export const getExportarPqAtual = (id: any) => {
  api.get<any>(`planilhaQuantidade/ObterNomePqAtualPorContratoId/${id}`).then(nome => {
    let urlBase = window.location.origin;

    Axios.get(urlBase + `/api/planilhaQuantidade/exportarPqAtual/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    });
  });
};

export const getExportarPqTakeOffMultiplosGestores = (id: any) => {
  let urlBase = window.location.origin;

  Axios.get(urlBase + `/api/planilhaQuantidade/ExportarPqConsolidada/${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Take-Off Consolidado.xlsx');
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const getExportarPqAtualMultiplosGestores = (id: any, identificador: number) => {
  api.get<any>(`planilhaQuantidade/ObterNomePqAtualMultiplosGestoresPorContratoId/${id}/${identificador}`).then(nome => {
    if(nome){
      let urlBase = window.location.origin;

      Axios.get(urlBase + `/api/planilhaQuantidade/exportarPqAtualMultiplosGestores/${id}/${identificador}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nome);
        link.setAttribute('id', 'downloadElement');
        document.body.appendChild(link);
        link.click();
        document.getElementById('downloadElement').outerHTML = '';
      });
    }else{
      Modal.warn({
        centered: true,
        okText: 'OK',
        title: 'Não possui arquivo de Planilha de Quantidade vinculado!',
      });
    }
  });
};

export const getExportarTaKeOf = (id: any) => {
  let urlBase = window.location.origin;

  api.get<any>(`contratos/GetValidateTakeOfByContratoId/${id}`).then(validacao => {
    if (validacao.valid === true) {
      trackPromise(
        Axios.get(urlBase + `/api/contratos/GetTakeOfByContratoId/${id}`, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getJwt()}`,
          },
        }).then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'takeOff.xlsx');
          link.setAttribute('id', 'takeOffFile');
          document.body.appendChild(link);
          link.click();
          document.getElementById('takeOffFile').outerHTML = '';
        }),
      );
    } else {
      validacao.notifications.forEach(item => {
        notification.error(item.message);
      });
      validacao.data = undefined;
    }
  });
};


export const getExportarTaKeOfAtual = (id: any) => {
  let urlBase = window.location.origin;

  api.get<any>(`contratos/GetValidateTakeOfByContratoId/${id}`).then(validacao => {
    if (validacao.valid === true) {
      trackPromise(
        Axios.get(urlBase + `/api/contratos/GeTakeOftAtualByContratoId/${id}`, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getJwt()}`,
          },
        }).then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'takeOff.xlsx');
          link.setAttribute('id', 'takeOffFile');
          document.body.appendChild(link);
          link.click();
          document.getElementById('takeOffFile').outerHTML = '';
        }),
      );
    } else {
      validacao.notifications.forEach(item => {
        notification.error(item.message);
      });
      validacao.data = undefined;
    }
  });
};

export const GetTakeOfMultiplosGestores = (id: any) => {
  let urlBase = window.location.origin;

  api.get<any>(`contratos/GetTakeMultiplosGestoresOfByContratoId/${id}`).then(validacao => {
    trackPromise(
      Axios.get(urlBase + `/api/contratos/GetTakeMultiplosGestoresOfByContratoId/${id}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'takeOff.xlsx');
        link.setAttribute('id', 'takeOffFile');
        document.body.appendChild(link);
        link.click();
        document.getElementById('takeOffFile').outerHTML = '';
      }),
    );
  });
};

export const getExportaPqTemporaria = (id: any) => {
  api.get<any>(`planilhaQuantidade/ObterNomePqTemporiaPorContratoId/${id}`).then(nome => {
    let urlBase = window.location.origin;
    Axios.get(urlBase + `/api/planilhaQuantidade/exportaPqTemporaria/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    });
  });
};

export const postAprovarPq = (id: any) => api.post<string>(`planilhaQuantidade/aprovarPq/${id}`);
export const postReprovarPq = (id: any) => api.post<string>(`planilhaQuantidade/reprovarPq/${id}`);
export const postExcluirPqTemporaria = (id: any) => api.delete<string>(`planilhaQuantidade/excluirPqTemporaria/${id}`);
export const postExcluirPqById = (id: any) => api.delete<any>(`planilhaQuantidade/excluirPqById/${id}`);
export const getVerificarTemporariaComStatusReprovada = (id: any) =>
  api.get<any>(`planilhaQuantidade/getVerificarTemporariaComStatusReprovada/${id}`);
export const getVerofocarTemporariaComStatusAguardandoAprovacao = (id: any) =>
  api.get<any>(`planilhaQuantidade/getVerofocarTemporariaComStatusAguardandoAprovacao/${id}`);

export const getAllTipoDocumentoCobranca = (id: string) =>
  api.get<TipoDocumentoCobranca[]>('tiposDocumentoCobranca/' + id);
export const getAllTipoDocumentoCobrancaOptions = (id: string) =>
  getAllTipoDocumentoCobranca(id).then(tipo => (tipo || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const updateTipoDocumentoCobranca = (id: string, tipoId: string) =>
  api.post(`planilhaQuantidade/updateTipoDocumentoCobranca`, { id, tipoId });

export const getAllTipoDocumentoCobrancaByMedicao = (id: string) =>
  api.get<TipoDocumentoCobranca[]>('tiposDocumentoCobranca/getAllByMedicao/' + id);

export const getAllTipoDocumentoCobrancaByMedicaoOptions = (id: string) =>
  getAllTipoDocumentoCobrancaByMedicao(id).then(tipo =>
    (tipo || []).map(a => ({ text: a.nome, value: a.id.toString() })),
  );
